import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import PageRoutes from "../Config/PageRoutes";
const Logo = () => {
  return (
    <Box
      container
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      {/* <Link to={PageRoutes.CHAPTER_ONE}> */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="165"
        height="146.943"
        viewBox="0 0 165 146.943"
      >
        <g
          id="Group_3657"
          data-name="Group 3657"
          transform="translate(-16 -22.057)"
        >
          <text
            id="_Light_Theme_1._Headline_H5"
            data-name="🌕 Light Theme/1. Headline/H5"
            transform="translate(16 79)"
            fill="#fff"
            font-size="18"
            font-family="Roboto-Regular, Roboto"
            letter-spacing="0.007em"
          >
            <tspan x="0" y="19">
              The 2023 European{" "}
            </tspan>
            <tspan x="0" y="41">
              Union report on{" "}
            </tspan>
            <tspan
              x="0"
              y="63"
              font-family="Roboto-Bold, Roboto"
              font-weight="700"
            >
              pesticide residues{" "}
            </tspan>
            <tspan
              x="0"
              y="85"
              font-family="Roboto-Bold, Roboto"
              font-weight="700"
            >
              in food
            </tspan>
          </text>
          <line
            id="Line_1050"
            data-name="Line 1050"
            x2="136"
            transform="translate(16.5 73.5)"
            fill="none"
            stroke="#fff"
            stroke-width="0.6"
          />
          <g
            id="Group_3570"
            data-name="Group 3570"
            transform="translate(-36 10)"
          >
            <path
              id="Path_3896"
              data-name="Path 3896"
              d="M386.5,235.243H363.1V219.51h23.4Zm-23.011-.392h22.619V219.9H363.492Z"
              transform="translate(-214.818 -191.85)"
              fill="#fff"
            />
            <path
              id="Path_3897"
              data-name="Path 3897"
              d="M371.648,230.915l.186-.574-.493-.354h.608l.186-.583.186.581h.608l-.494.354.185.574-.485-.354Z"
              transform="translate(-217.182 -194.689)"
              fill="#fff"
            />
            <path
              id="Path_3898"
              data-name="Path 3898"
              d="M373.873,233.517l-.493.354.186.573-.486-.354-.485.354.184-.573-.493-.354h.608l.186-.581.185.581Z"
              transform="translate(-217.453 -195.701)"
              fill="#fff"
            />
            <path
              id="Path_3899"
              data-name="Path 3899"
              d="M373.266,226.469h.608l-.494.354.186.573-.486-.354-.484.354.184-.573-.494-.354h.608l.186-.581Z"
              transform="translate(-217.453 -193.68)"
              fill="#fff"
            />
            <path
              id="Path_3900"
              data-name="Path 3900"
              d="M375.357,224.239l-.493-.354h.608l.186-.581.186.58h.608l-.492.354.184.574-.486-.354-.484.354Z"
              transform="translate(-218.192 -192.939)"
              fill="#fff"
            />
            <path
              id="Path_3901"
              data-name="Path 3901"
              d="M376.457,236.1l-.492.354.185.573-.486-.354-.485.354.184-.573-.491-.354h.606l.186-.579.185.579Z"
              transform="translate(-218.194 -196.443)"
              fill="#fff"
            />
            <path
              id="Path_3902"
              data-name="Path 3902"
              d="M378.88,223.293l-.492-.354h.606l.188-.581.186.581h.606l-.492.354.184.572-.484-.354-.486.354Z"
              transform="translate(-219.203 -192.668)"
              fill="#fff"
            />
            <path
              id="Path_3903"
              data-name="Path 3903"
              d="M379.976,237.035l-.493.354.184.574-.484-.354-.486.354.185-.574-.493-.354.608,0,.186-.583.185.581Z"
              transform="translate(-219.203 -196.711)"
              fill="#fff"
            />
            <path
              id="Path_3904"
              data-name="Path 3904"
              d="M383.494,236.1l-.493.354.186.573-.486-.354-.485.354.184-.573-.493-.354h.608l.186-.579.185.579Z"
              transform="translate(-220.212 -196.443)"
              fill="#fff"
            />
            <path
              id="Path_3905"
              data-name="Path 3905"
              d="M382.9,223.885h.608l-.494.356.186.572-.484-.354-.486.354.184-.572-.493-.356h.608l.186-.581Z"
              transform="translate(-220.215 -192.939)"
              fill="#fff"
            />
            <path
              id="Path_3906"
              data-name="Path 3906"
              d="M386.078,233.517l-.493.354.186.573-.486-.354-.485.354.184-.573-.491-.354h.606l.186-.581.188.581Z"
              transform="translate(-220.954 -195.701)"
              fill="#fff"
            />
            <path
              id="Path_3907"
              data-name="Path 3907"
              d="M384.983,226.813l-.492-.354h.606l.186-.581.188.581h.606l-.494.354.186.572-.486-.354-.484.354Z"
              transform="translate(-220.953 -193.678)"
              fill="#fff"
            />
            <path
              id="Path_3908"
              data-name="Path 3908"
              d="M386.521,230.332l.184.574-.486-.356-.484.356.184-.574-.492-.354h.606l.186-.581.186.58h.608Z"
              transform="translate(-221.222 -194.688)"
              fill="#fff"
            />
            <path
              id="Path_3909"
              data-name="Path 3909"
              d="M260.088,219.4a16,16,0,1,1-31.992,0h5.569a10.427,10.427,0,1,0,20.855,0Z"
              transform="translate(-176.096 -191.82)"
              fill="#fff"
            />
            <path
              id="Path_3910"
              data-name="Path 3910"
              d="M247.066,225.689a8.566,8.566,0,0,0,6.4-14.262,26.006,26.006,0,0,0-6.4,11.519,18.607,18.607,0,0,0-8.569-5.762,8.581,8.581,0,0,0,8.57,8.5"
              transform="translate(-179.079 -189.533)"
              fill="#fff"
            />
            <path
              id="Path_3911"
              data-name="Path 3911"
              d="M265.3,203.885a.207.207,0,1,0-.135-.26.207.207,0,0,0,.135.26"
              transform="translate(-186.725 -187.252)"
              fill="#fff"
            />
            <path
              id="Path_3912"
              data-name="Path 3912"
              d="M263.589,201.96a.226.226,0,1,0,.147.284.226.226,0,0,0-.147-.284"
              transform="translate(-186.191 -186.814)"
              fill="#fff"
            />
            <path
              id="Path_3913"
              data-name="Path 3913"
              d="M261.6,200.652a.235.235,0,1,0,.153.3.235.235,0,0,0-.153-.3"
              transform="translate(-185.619 -186.439)"
              fill="#fff"
            />
            <path
              id="Path_3914"
              data-name="Path 3914"
              d="M259.485,199.566a.244.244,0,1,0,.158.306.243.243,0,0,0-.158-.306"
              transform="translate(-185.008 -186.127)"
              fill="#fff"
            />
            <path
              id="Path_3915"
              data-name="Path 3915"
              d="M257.113,199.2a.253.253,0,1,0-.164-.317.252.252,0,0,0,.164.317"
              transform="translate(-184.369 -185.885)"
              fill="#fff"
            />
            <path
              id="Path_3916"
              data-name="Path 3916"
              d="M254.812,198.6a.261.261,0,1,0-.17-.328.262.262,0,0,0,.17.328"
              transform="translate(-183.707 -185.709)"
              fill="#fff"
            />
            <path
              id="Path_3917"
              data-name="Path 3917"
              d="M252.459,198.262a.27.27,0,1,0-.175-.339.27.27,0,0,0,.175.339"
              transform="translate(-183.03 -185.605)"
              fill="#fff"
            />
            <path
              id="Path_3918"
              data-name="Path 3918"
              d="M250.083,198.177a.278.278,0,1,0-.181-.349.278.278,0,0,0,.181.349"
              transform="translate(-182.347 -185.576)"
              fill="#fff"
            />
            <path
              id="Path_3919"
              data-name="Path 3919"
              d="M247.711,198.35a.287.287,0,1,0-.187-.361.288.288,0,0,0,.187.361"
              transform="translate(-181.665 -185.621)"
              fill="#fff"
            />
            <path
              id="Path_3920"
              data-name="Path 3920"
              d="M245.371,198.781a.3.3,0,1,0-.193-.372.3.3,0,0,0,.193.372"
              transform="translate(-180.992 -185.74)"
              fill="#fff"
            />
            <path
              id="Path_3921"
              data-name="Path 3921"
              d="M243.092,199.46a.3.3,0,1,0-.2-.382.3.3,0,0,0,.2.382"
              transform="translate(-180.336 -185.93)"
              fill="#fff"
            />
            <path
              id="Path_3922"
              data-name="Path 3922"
              d="M240.9,200.38a.313.313,0,1,0-.2-.394.314.314,0,0,0,.2.394"
              transform="translate(-179.706 -186.189)"
              fill="#fff"
            />
            <path
              id="Path_3923"
              data-name="Path 3923"
              d="M238.817,201.53a.322.322,0,1,0-.21-.4.322.322,0,0,0,.21.4"
              transform="translate(-179.106 -186.514)"
              fill="#fff"
            />
            <path
              id="Path_3924"
              data-name="Path 3924"
              d="M236.869,202.9a.331.331,0,1,0-.215-.415.331.331,0,0,0,.215.415"
              transform="translate(-178.546 -186.902)"
              fill="#fff"
            />
            <path
              id="Path_3925"
              data-name="Path 3925"
              d="M235.081,204.464a.339.339,0,1,0-.221-.426.34.34,0,0,0,.221.426"
              transform="translate(-178.032 -187.346)"
              fill="#fff"
            />
            <path
              id="Path_3926"
              data-name="Path 3926"
              d="M233.472,206.216a.348.348,0,1,0-.227-.437.348.348,0,0,0,.227.437"
              transform="translate(-177.568 -187.842)"
              fill="#fff"
            />
            <path
              id="Path_3927"
              data-name="Path 3927"
              d="M232.063,208.132a.357.357,0,1,0-.232-.448.356.356,0,0,0,.232.448"
              transform="translate(-177.163 -188.387)"
              fill="#fff"
            />
            <path
              id="Path_3928"
              data-name="Path 3928"
              d="M230.87,210.19a.366.366,0,1,0-.237-.459.365.365,0,0,0,.237.459"
              transform="translate(-176.819 -188.973)"
              fill="#fff"
            />
            <path
              id="Path_3929"
              data-name="Path 3929"
              d="M229.905,212.364a.374.374,0,1,0-.243-.47.374.374,0,0,0,.243.47"
              transform="translate(-176.54 -189.592)"
              fill="#fff"
            />
            <path
              id="Path_3930"
              data-name="Path 3930"
              d="M229.685,214.375a.429.429,0,1,0-.538.279.429.429,0,0,0,.538-.279"
              transform="translate(-176.312 -190.219)"
              fill="#fff"
            />
            <path
              id="Path_3931"
              data-name="Path 3931"
              d="M229.223,216.7a.45.45,0,1,0-.566.293.45.45,0,0,0,.566-.293"
              transform="translate(-176.167 -190.877)"
              fill="#fff"
            />
            <path
              id="Path_3932"
              data-name="Path 3932"
              d="M230.6,217.023a.449.449,0,1,0-.292-.564.45.45,0,0,0,.292.564"
              transform="translate(-176.726 -190.887)"
              fill="#fff"
            />
            <path
              id="Path_3933"
              data-name="Path 3933"
              d="M231.132,214.7a.427.427,0,1,0-.277-.536.426.426,0,0,0,.277.536"
              transform="translate(-176.882 -190.232)"
              fill="#fff"
            />
            <path
              id="Path_3934"
              data-name="Path 3934"
              d="M231.71,211.969a.371.371,0,1,0,.466-.242.372.372,0,0,0-.466.242"
              transform="translate(-177.128 -189.613)"
              fill="#fff"
            />
            <path
              id="Path_3935"
              data-name="Path 3935"
              d="M233.451,210.066a.362.362,0,1,0-.454.235.362.362,0,0,0,.454-.235"
              transform="translate(-177.43 -189.008)"
              fill="#fff"
            />
            <path
              id="Path_3936"
              data-name="Path 3936"
              d="M234.056,207.865a.352.352,0,1,0,.442-.229.352.352,0,0,0-.442.229"
              transform="translate(-177.801 -188.441)"
              fill="#fff"
            />
            <path
              id="Path_3937"
              data-name="Path 3937"
              d="M236.009,205.828a.343.343,0,1,0,.223.431.344.344,0,0,0-.223-.431"
              transform="translate(-178.237 -187.924)"
              fill="#fff"
            />
            <path
              id="Path_3938"
              data-name="Path 3938"
              d="M237.525,204.846a.333.333,0,1,0-.217-.419.334.334,0,0,0,.217.419"
              transform="translate(-178.734 -187.457)"
              fill="#fff"
            />
            <path
              id="Path_3939"
              data-name="Path 3939"
              d="M239.428,203.427a.324.324,0,1,0-.21-.407.324.324,0,0,0,.21.407"
              transform="translate(-179.282 -187.057)"
              fill="#fff"
            />
            <path
              id="Path_3940"
              data-name="Path 3940"
              d="M241.484,202.239a.314.314,0,1,0-.2-.394.314.314,0,0,0,.2.394"
              transform="translate(-179.873 -186.723)"
              fill="#fff"
            />
            <path
              id="Path_3941"
              data-name="Path 3941"
              d="M243.665,201.3a.3.3,0,1,0-.2-.383.305.305,0,0,0,.2.383"
              transform="translate(-180.5 -186.459)"
              fill="#fff"
            />
            <path
              id="Path_3942"
              data-name="Path 3942"
              d="M245.939,200.626a.3.3,0,1,0-.192-.371.3.3,0,0,0,.192.371"
              transform="translate(-181.155 -186.27)"
              fill="#fff"
            />
            <path
              id="Path_3943"
              data-name="Path 3943"
              d="M248.277,200.223a.286.286,0,1,0-.186-.359.286.286,0,0,0,.186.359"
              transform="translate(-181.827 -186.158)"
              fill="#fff"
            />
            <path
              id="Path_3944"
              data-name="Path 3944"
              d="M250.646,200.1a.276.276,0,1,0-.18-.347.275.275,0,0,0,.18.347"
              transform="translate(-182.509 -186.129)"
              fill="#fff"
            />
            <path
              id="Path_3945"
              data-name="Path 3945"
              d="M253.013,200.261a.267.267,0,1,0-.173-.335.267.267,0,0,0,.173.335"
              transform="translate(-183.189 -186.18)"
              fill="#fff"
            />
            <path
              id="Path_3946"
              data-name="Path 3946"
              d="M255.345,200.7a.257.257,0,1,0-.168-.323.257.257,0,0,0,.168.323"
              transform="translate(-183.86 -186.313)"
              fill="#fff"
            />
            <path
              id="Path_3947"
              data-name="Path 3947"
              d="M257.609,201.406a.248.248,0,1,0-.161-.311.247.247,0,0,0,.161.311"
              transform="translate(-184.512 -186.52)"
              fill="#fff"
            />
            <path
              id="Path_3948"
              data-name="Path 3948"
              d="M259.918,201.919a.238.238,0,1,0,.155.3.238.238,0,0,0-.155-.3"
              transform="translate(-185.135 -186.803)"
              fill="#fff"
            />
            <path
              id="Path_3949"
              data-name="Path 3949"
              d="M261.946,203.155a.229.229,0,1,0,.148.287.228.228,0,0,0-.148-.287"
              transform="translate(-185.72 -187.158)"
              fill="#fff"
            />
            <path
              id="Path_3950"
              data-name="Path 3950"
              d="M263.69,205.033a.208.208,0,1,0-.135-.261.207.207,0,0,0,.135.261"
              transform="translate(-186.263 -187.582)"
              fill="#fff"
            />
            <path
              id="Path_3951"
              data-name="Path 3951"
              d="M232.268,216.456a.447.447,0,1,0,.562-.291.448.448,0,0,0-.562.291"
              transform="translate(-177.287 -190.887)"
              fill="#fff"
            />
            <path
              id="Path_3952"
              data-name="Path 3952"
              d="M232.866,214.181a.424.424,0,1,0,.532-.276.424.424,0,0,0-.532.276"
              transform="translate(-177.459 -190.238)"
              fill="#fff"
            />
            <path
              id="Path_3953"
              data-name="Path 3953"
              d="M234.261,211.78a.368.368,0,1,0,.24.462.368.368,0,0,0-.24-.462"
              transform="translate(-177.727 -189.629)"
              fill="#fff"
            />
            <path
              id="Path_3954"
              data-name="Path 3954"
              d="M234.949,209.957a.358.358,0,1,0,.449-.232.357.357,0,0,0-.449.232"
              transform="translate(-178.057 -189.039)"
              fill="#fff"
            />
            <path
              id="Path_3955"
              data-name="Path 3955"
              d="M236.8,207.836a.347.347,0,1,0,.226.436.347.347,0,0,0-.226-.436"
              transform="translate(-178.462 -188.498)"
              fill="#fff"
            />
            <path
              id="Path_3956"
              data-name="Path 3956"
              d="M238.231,206.79a.336.336,0,1,0-.219-.422.336.336,0,0,0,.219.422"
              transform="translate(-178.936 -188.014)"
              fill="#fff"
            />
            <path
              id="Path_3957"
              data-name="Path 3957"
              d="M240.083,205.31a.326.326,0,1,0-.212-.409.326.326,0,0,0,.212.409"
              transform="translate(-179.469 -187.596)"
              fill="#fff"
            />
            <path
              id="Path_3958"
              data-name="Path 3958"
              d="M241.9,203.687a.315.315,0,1,0,.4-.205.315.315,0,0,0-.4.205"
              transform="translate(-180.052 -187.25)"
              fill="#fff"
            />
            <path
              id="Path_3959"
              data-name="Path 3959"
              d="M244.078,202.745a.3.3,0,1,0,.383-.2.305.305,0,0,0-.383.2"
              transform="translate(-180.676 -186.982)"
              fill="#fff"
            />
            <path
              id="Path_3960"
              data-name="Path 3960"
              d="M246.357,202.093a.294.294,0,1,0,.369-.192.294.294,0,0,0-.369.192"
              transform="translate(-181.33 -186.797)"
              fill="#fff"
            />
            <path
              id="Path_3961"
              data-name="Path 3961"
              d="M249.061,201.558a.284.284,0,1,0,.185.357.283.283,0,0,0-.185-.357"
              transform="translate(-182.003 -186.699)"
              fill="#fff"
            />
            <path
              id="Path_3962"
              data-name="Path 3962"
              d="M251.256,202.043a.273.273,0,1,0-.178-.343.273.273,0,0,0,.178.343"
              transform="translate(-182.685 -186.688)"
              fill="#fff"
            />
            <path
              id="Path_3963"
              data-name="Path 3963"
              d="M253.609,202.3a.263.263,0,1,0-.171-.33.263.263,0,0,0,.171.33"
              transform="translate(-183.361 -186.768)"
              fill="#fff"
            />
            <path
              id="Path_3964"
              data-name="Path 3964"
              d="M255.908,202.857a.252.252,0,1,0-.164-.317.252.252,0,0,0,.164.317"
              transform="translate(-184.023 -186.934)"
              fill="#fff"
            />
            <path
              id="Path_3965"
              data-name="Path 3965"
              d="M258.264,203.245a.242.242,0,1,0,.158.3.242.242,0,0,0-.158-.3"
              transform="translate(-184.659 -187.184)"
              fill="#fff"
            />
            <path
              id="Path_3966"
              data-name="Path 3966"
              d="M260.336,204.4a.231.231,0,1,0,.15.29.231.231,0,0,0-.15-.29"
              transform="translate(-185.257 -187.514)"
              fill="#fff"
            />
            <path
              id="Path_3967"
              data-name="Path 3967"
              d="M262.241,205.821a.21.21,0,1,0,.136.263.209.209,0,0,0-.136-.263"
              transform="translate(-185.812 -187.924)"
              fill="#fff"
            />
            <path
              id="Path_3968"
              data-name="Path 3968"
              d="M235.081,216.726a.446.446,0,1,0-.559.29.446.446,0,0,0,.559-.29"
              transform="translate(-177.85 -190.887)"
              fill="#fff"
            />
            <path
              id="Path_3969"
              data-name="Path 3969"
              d="M234.895,214.2a.421.421,0,1,0,.528-.274.42.42,0,0,0-.528.274"
              transform="translate(-178.041 -190.246)"
              fill="#fff"
            />
            <path
              id="Path_3970"
              data-name="Path 3970"
              d="M235.922,212.091a.364.364,0,1,0,.457-.237.364.364,0,0,0-.457.237"
              transform="translate(-178.336 -189.65)"
              fill="#fff"
            />
            <path
              id="Path_3971"
              data-name="Path 3971"
              d="M237.634,209.877a.352.352,0,1,0,.229.442.352.352,0,0,0-.229-.442"
              transform="translate(-178.701 -189.084)"
              fill="#fff"
            />
            <path
              id="Path_3972"
              data-name="Path 3972"
              d="M238.962,208.757a.34.34,0,1,0-.222-.427.34.34,0,0,0,.222.427"
              transform="translate(-179.145 -188.576)"
              fill="#fff"
            />
            <path
              id="Path_3973"
              data-name="Path 3973"
              d="M240.946,206.58a.329.329,0,1,0,.214.413.329.329,0,0,0-.214-.413"
              transform="translate(-179.659 -188.139)"
              fill="#fff"
            />
            <path
              id="Path_3974"
              data-name="Path 3974"
              d="M242.929,205.327a.317.317,0,1,0,.206.4.317.317,0,0,0-.206-.4"
              transform="translate(-180.232 -187.777)"
              fill="#fff"
            />
            <path
              id="Path_3975"
              data-name="Path 3975"
              d="M245.074,204.374a.305.305,0,1,0,.2.383.3.3,0,0,0-.2-.383"
              transform="translate(-180.852 -187.506)"
              fill="#fff"
            />
            <path
              id="Path_3976"
              data-name="Path 3976"
              d="M246.968,203.934a.293.293,0,1,0,.369-.191.293.293,0,0,0-.369.191"
              transform="translate(-181.505 -187.324)"
              fill="#fff"
            />
            <path
              id="Path_3977"
              data-name="Path 3977"
              d="M249.853,203.8a.282.282,0,1,0-.354.183.282.282,0,0,0,.354-.183"
              transform="translate(-182.178 -187.24)"
              fill="#fff"
            />
            <path
              id="Path_3978"
              data-name="Path 3978"
              d="M252.024,203.5a.27.27,0,1,0,.175.339.27.27,0,0,0-.175-.339"
              transform="translate(-182.858 -187.254)"
              fill="#fff"
            />
            <path
              id="Path_3979"
              data-name="Path 3979"
              d="M254.192,204.384a.258.258,0,1,0-.168-.325.258.258,0,0,0,.168.325"
              transform="translate(-183.529 -187.369)"
              fill="#fff"
            />
            <path
              id="Path_3980"
              data-name="Path 3980"
              d="M256.595,204.617a.247.247,0,1,0,.16.31.246.246,0,0,0-.16-.31"
              transform="translate(-184.178 -187.576)"
              fill="#fff"
            />
            <path
              id="Path_3981"
              data-name="Path 3981"
              d="M258.715,205.66a.235.235,0,1,0,.153.295.235.235,0,0,0-.153-.295"
              transform="translate(-184.791 -187.875)"
              fill="#fff"
            />
            <path
              id="Path_3982"
              data-name="Path 3982"
              d="M260.662,207.017a.212.212,0,1,0,.138.266.212.212,0,0,0-.138-.266"
              transform="translate(-185.357 -188.266)"
              fill="#fff"
            />
            <path
              id="Path_3983"
              data-name="Path 3983"
              d="M324.047,221.9l-2.96,1.575q-.7-1.432-1.735-1.432a1.2,1.2,0,0,0-.844.326,1.094,1.094,0,0,0-.35.836q0,.891,2.069,1.767a12.338,12.338,0,0,1,3.836,2.26,3.865,3.865,0,0,1,.987,2.785,4.881,4.881,0,0,1-1.655,3.756,5.934,5.934,0,0,1-9.405-2.371l3.055-1.416a6.632,6.632,0,0,0,.971,1.416,2.214,2.214,0,0,0,1.56.6q1.815,0,1.814-1.655,0-.955-1.4-1.783-.541-.271-1.083-.525t-1.1-.526a6.718,6.718,0,0,1-2.2-1.528,3.762,3.762,0,0,1-.812-2.5,4.424,4.424,0,0,1,1.384-3.343,4.86,4.86,0,0,1,3.438-1.321,4.691,4.691,0,0,1,4.425,3.072"
              transform="translate(-200.732 -191.656)"
              fill="#fff"
            />
            <path
              id="Path_3984"
              data-name="Path 3984"
              d="M230.884,247.061h-1.961v1.17h1.9v.69h-1.9v1.627h1.961v.691h-2.7V246.37h2.7Z"
              transform="translate(-176.122 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3985"
              data-name="Path 3985"
              d="M234.066,246.37V249.3a1.606,1.606,0,0,0,.206.918,1.1,1.1,0,0,0,1.732,0,1.584,1.584,0,0,0,.205-.918V246.37h.738V249.5a1.75,1.75,0,0,1-.481,1.268,1.868,1.868,0,0,1-2.657,0,1.75,1.75,0,0,1-.481-1.268V246.37Z"
              transform="translate(-177.597 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3986"
              data-name="Path 3986"
              d="M241.7,249.164l1.514,2.075h-.9l-1.4-1.993h-.133v1.993h-.738V246.37h.865a2.168,2.168,0,0,1,1.4.362,1.331,1.331,0,0,1,.475,1.066,1.381,1.381,0,0,1-.3.889,1.324,1.324,0,0,1-.785.476m-.919-.558h.235q1.047,0,1.048-.8,0-.747-1.02-.747h-.263Z"
              transform="translate(-179.524 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3987"
              data-name="Path 3987"
              d="M245.026,248.746a2.377,2.377,0,0,1,.757-1.766,2.5,2.5,0,0,1,1.811-.738,2.552,2.552,0,0,1,2.543,2.533,2.388,2.388,0,0,1-.754,1.782,2.593,2.593,0,0,1-3.528.082,2.387,2.387,0,0,1-.829-1.892m.744.009a1.814,1.814,0,0,0,3.094,1.318,1.885,1.885,0,0,0,.006-2.611,1.829,1.829,0,0,0-2.575,0,1.754,1.754,0,0,0-.526,1.293"
              transform="translate(-180.952 -199.52)"
              fill="#fff"
            />
            <path
              id="Path_3988"
              data-name="Path 3988"
              d="M254.231,249.262v1.977h-.738V246.37h.837a3.768,3.768,0,0,1,.928.086,1.241,1.241,0,0,1,.557.322,1.381,1.381,0,0,1,.421,1.034,1.332,1.332,0,0,1-.45,1.06,1.785,1.785,0,0,1-1.212.391Zm0-.681h.275q1.017,0,1.017-.779,0-.754-1.048-.754h-.244Z"
              transform="translate(-183.38 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3989"
              data-name="Path 3989"
              d="M261.1,247.061h-1.961v1.17h1.9v.69h-1.9v1.627H261.1v.691h-2.7V246.37h2.7Z"
              transform="translate(-184.79 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3990"
              data-name="Path 3990"
              d="M266.2,249.933H264.1l-.544,1.183h-.794l2.42-5.175,2.334,5.175h-.808Zm-.3-.69-.725-1.655-.761,1.655Z"
              transform="translate(-186.039 -199.432)"
              fill="#fff"
            />
            <path
              id="Path_3991"
              data-name="Path 3991"
              d="M270.284,251.106v-5.2l3.566,3.714v-3.383h.738V251.4l-3.566-3.706v3.409Z"
              transform="translate(-188.196 -199.422)"
              fill="#fff"
            />
            <path
              id="Path_3992"
              data-name="Path 3992"
              d="M283.211,247.061h-1.7v1.17h1.644v.69h-1.644v2.318h-.738V246.37h2.442Z"
              transform="translate(-191.204 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3993"
              data-name="Path 3993"
              d="M285.059,248.746a2.377,2.377,0,0,1,.757-1.766,2.5,2.5,0,0,1,1.811-.738,2.552,2.552,0,0,1,2.543,2.533,2.391,2.391,0,0,1-.754,1.782,2.593,2.593,0,0,1-3.528.082,2.387,2.387,0,0,1-.829-1.892m.744.009a1.814,1.814,0,0,0,3.095,1.318,1.885,1.885,0,0,0,.006-2.611,1.829,1.829,0,0,0-2.575,0,1.754,1.754,0,0,0-.526,1.293"
              transform="translate(-192.435 -199.52)"
              fill="#fff"
            />
            <path
              id="Path_3994"
              data-name="Path 3994"
              d="M293.186,248.746a2.377,2.377,0,0,1,.757-1.766,2.5,2.5,0,0,1,1.811-.738,2.552,2.552,0,0,1,2.543,2.533,2.391,2.391,0,0,1-.754,1.782,2.593,2.593,0,0,1-3.528.082,2.387,2.387,0,0,1-.829-1.892m.744.009a1.814,1.814,0,0,0,3.094,1.318,1.885,1.885,0,0,0,.006-2.611,1.829,1.829,0,0,0-2.575,0,1.754,1.754,0,0,0-.526,1.293"
              transform="translate(-194.766 -199.52)"
              fill="#fff"
            />
            <path
              id="Path_3995"
              data-name="Path 3995"
              d="M301.654,251.239V246.37h1.026a3.735,3.735,0,0,1,1.165.146,2.174,2.174,0,0,1,.833.482,2.51,2.51,0,0,1-.031,3.624,2.3,2.3,0,0,1-.83.482,3.787,3.787,0,0,1-1.15.135Zm.738-.69h.332a2.768,2.768,0,0,0,.827-.1,1.782,1.782,0,0,0,.6-2.939,2.047,2.047,0,0,0-1.429-.444h-.332Z"
              transform="translate(-197.194 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3996"
              data-name="Path 3996"
              d="M313.731,247.057l-.6.353a1.023,1.023,0,0,0-.32-.378.745.745,0,0,0-.409-.1.758.758,0,0,0-.51.173.538.538,0,0,0-.2.429q0,.356.532.573l.488.2a2.08,2.08,0,0,1,.871.585,1.314,1.314,0,0,1,.275.847,1.486,1.486,0,0,1-.449,1.11,1.546,1.546,0,0,1-1.124.441,1.509,1.509,0,0,1-1.052-.375,1.727,1.727,0,0,1-.51-1.056l.747-.165a1.269,1.269,0,0,0,.178.593.845.845,0,0,0,1.238.085.8.8,0,0,0,.228-.583.816.816,0,0,0-.039-.26.671.671,0,0,0-.124-.218.982.982,0,0,0-.217-.186,2.129,2.129,0,0,0-.317-.165l-.472-.2q-1-.423-1-1.236a1.172,1.172,0,0,1,.421-.918,1.526,1.526,0,0,1,1.048-.372,1.464,1.464,0,0,1,1.321.82"
              transform="translate(-199.795 -199.518)"
              fill="#fff"
            />
            <path
              id="Path_3997"
              data-name="Path 3997"
              d="M318.942,249.933h-2.093l-.545,1.183h-.8l2.42-5.175,2.334,5.175h-.808Zm-.3-.69-.725-1.655-.76,1.655Z"
              transform="translate(-201.168 -199.432)"
              fill="#fff"
            />
            <path
              id="Path_3998"
              data-name="Path 3998"
              d="M325.474,247.061h-1.7v1.17h1.644v.69H323.77v2.318h-.738V246.37h2.442Z"
              transform="translate(-203.326 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_3999"
              data-name="Path 3999"
              d="M330.353,247.061h-1.961v1.17h1.9v.69h-1.9v1.627h1.961v.691h-2.7V246.37h2.7Z"
              transform="translate(-204.652 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4000"
              data-name="Path 4000"
              d="M333.94,247.061v4.179H333.2v-4.179h-1.124v-.69h2.983v.69Z"
              transform="translate(-205.92 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4001"
              data-name="Path 4001"
              d="M338.372,249.136l-1.6-2.766h.849l1.118,1.946,1.121-1.946h.849l-1.6,2.766v2.1h-.738Z"
              transform="translate(-207.268 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4002"
              data-name="Path 4002"
              d="M348.54,249.933h-2.093l-.545,1.183h-.8l2.42-5.175,2.334,5.175h-.808Zm-.3-.69-.725-1.655-.76,1.655Z"
              transform="translate(-209.657 -199.432)"
              fill="#fff"
            />
            <path
              id="Path_4003"
              data-name="Path 4003"
              d="M353.105,246.37V249.3a1.6,1.6,0,0,0,.206.918,1.1,1.1,0,0,0,1.732,0,1.584,1.584,0,0,0,.205-.918V246.37h.738V249.5a1.75,1.75,0,0,1-.481,1.268,1.868,1.868,0,0,1-2.657,0,1.75,1.75,0,0,1-.481-1.268V246.37Z"
              transform="translate(-211.74 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4004"
              data-name="Path 4004"
              d="M360.23,247.061v4.179h-.738v-4.179h-1.124v-.69h2.983v.69Z"
              transform="translate(-213.46 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4005"
              data-name="Path 4005"
              d="M364.212,248.275h2.11v-1.9h.737v4.869h-.737v-2.274h-2.11v2.274h-.738V246.37h.738Z"
              transform="translate(-214.925 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4006"
              data-name="Path 4006"
              d="M369.8,248.746a2.377,2.377,0,0,1,.757-1.766,2.5,2.5,0,0,1,1.811-.738,2.551,2.551,0,0,1,2.543,2.533,2.389,2.389,0,0,1-.754,1.782,2.593,2.593,0,0,1-3.528.082,2.387,2.387,0,0,1-.829-1.892m.744.009a1.814,1.814,0,0,0,3.094,1.318,1.885,1.885,0,0,0,.006-2.611,1.829,1.829,0,0,0-2.575,0,1.754,1.754,0,0,0-.526,1.293"
              transform="translate(-216.741 -199.52)"
              fill="#fff"
            />
            <path
              id="Path_4007"
              data-name="Path 4007"
              d="M379.927,249.164l1.513,2.075h-.9l-1.4-1.993h-.133v1.993h-.738V246.37h.865a2.168,2.168,0,0,1,1.4.362,1.331,1.331,0,0,1,.475,1.066,1.381,1.381,0,0,1-.3.889,1.325,1.325,0,0,1-.785.476m-.919-.558h.235q1.047,0,1.048-.8,0-.747-1.02-.747h-.263Z"
              transform="translate(-219.169 -199.555)"
              fill="#fff"
            />
            <rect
              id="Rectangle_11333"
              data-name="Rectangle 11333"
              width="0.738"
              height="4.869"
              transform="translate(163.006 46.816)"
              fill="#fff"
            />
            <path
              id="Path_4008"
              data-name="Path 4008"
              d="M387.572,247.061v4.179h-.738v-4.179h-1.124v-.69h2.983v.69Z"
              transform="translate(-221.303 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4009"
              data-name="Path 4009"
              d="M392,249.136l-1.6-2.766h.849l1.118,1.946,1.121-1.946h.849l-1.6,2.766v2.1H392Z"
              transform="translate(-222.65 -199.555)"
              fill="#fff"
            />
            <path
              id="Path_4010"
              data-name="Path 4010"
              d="M286.45,230.384a4.718,4.718,0,0,1-8.015-1.6h12.411a8.069,8.069,0,1,0-.481,1.6Zm-3.542-7.848a4.725,4.725,0,0,1,4.473,3.209h-8.946a4.725,4.725,0,0,1,4.473-3.209"
              transform="translate(-189.499 -191.758)"
              fill="#fff"
            />
            <path
              id="Path_4011"
              data-name="Path 4011"
              d="M302.362,202.595a7.309,7.309,0,0,0-.772,1.656,6.628,6.628,0,0,0-.257,2.524v6.949h-1.286V217.1h1.286v12.283h3.634V217.1H308.9v-3.376h-3.938v-6.065a10.856,10.856,0,0,1,.138-1.953c.008-.039.016-.078.026-.116.018-.081.037-.156.058-.225l0-.007a2.1,2.1,0,0,1,.091-.25,3.132,3.132,0,0,1,3.623-1.876V199.9a6.5,6.5,0,0,0-6.543,2.693"
              transform="translate(-196.733 -186.199)"
              fill="#fff"
            />
            <path
              id="Path_4012"
              data-name="Path 4012"
              d="M345.47,219.322v1.357a7.991,7.991,0,1,0,0,13.425v.875h3.657V219.322Zm-4.274,12.8a4.734,4.734,0,0,1-4.71-4.256q-.024-.236-.024-.478t.024-.478a4.734,4.734,0,1,1,4.71,5.211"
              transform="translate(-206.226 -191.797)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>

      {/* </Link> */}
    </Box>
  );
};
export default Logo;
